import { QUERY_KEYS } from '@avanta/shared/constants/common';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { AppointmentService } from 'services/appointments';
import { useEnterpriseId } from 'stores/user';
import { type GetEnterpriseAppointmentsCountParams } from 'types/appointments';

export const useFetchEnterpriseAppointmentsCount = (
  params: GetEnterpriseAppointmentsCountParams = {},
  enabled = true
): UseQueryResult<number, Error> => {
  const enterpriseId = useEnterpriseId();

  return useQuery({
    queryKey: [QUERY_KEYS.FETCH_ENTERPRISE_APPOINTMENTS, enterpriseId, 'count', params],
    queryFn: async () => {
      const { data } = await AppointmentService.getEnterpriseAppointmentsCount(
        enterpriseId,
        params
      );
      return data.count;
    },
    enabled: Boolean(enterpriseId) && enabled,
  });
};
